/**
 * Slugify a brand name (or any string) for use in URLs.
 *
 * Examples:
 *   "Mercedes-Benz"  -> "mercedes-benz"
 *   "Citroën"        -> "citroen"
 *   "Audi"           -> "audi"
 *
 * IMPORTANT: must produce the same output as backend/routes/seo.py:slugify().
 */
export const slugify = (text) => {
  if (!text) return '';
  return text
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '') // strip combining diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)+/g, '');
};

// Resolve a slug back to the canonical brand name found in a list.
// Returns null when no brand matches.
export const findBrandFromSlug = (slug, brands) => {
  if (!slug || !Array.isArray(brands)) return null;
  const target = slug.toLowerCase();
  return brands.find((b) => slugify(b) === target) || null;
};

// Build the descriptive (non-unique) base of a car slug.
// Mirrors backend/routes/seo.py:build_car_slug_base.
// Example: buildCarSlugBase({brand:"Mercedes-Benz", model:"GLA 250", version:"e AMG Line", year:2022})
//       -> "mercedes-benz-gla-250-e-amg-line-2022"
export const buildCarSlugBase = (car) => {
  if (!car) return '';
  const parts = [];
  for (const key of ['brand', 'model', 'version']) {
    const s = slugify(car[key] || '');
    if (s) parts.push(s);
  }
  if (car.year) {
    const y = parseInt(car.year, 10);
    if (Number.isFinite(y)) parts.push(String(y));
  }
  return parts.join('-') || 'viatura';
};

// Return the path token for a car: prefer the stored unique slug, fall back to id.
export const carPathToken = (car) => {
  if (!car) return '';
  return car.slug || car.id || '';
};
